// Utility function to map currency codes to symbols
const currencySymbols = {
  INR: "₹",
  USD: "$",
  EUR: "€",
  GBP: "£",
  JPY: "¥",
  AUD: "A$",
  CAD: "C$",
  CNY: "¥",
  AED: "د.إ",
  SGD: "S$",
  CHF: "CHF",
  KRW: "₩",
  THB: "฿",
  RUB: "₽",
};

// Function to get currency symbol from localStorage user data
export  function getCurrencySymbol() {
  try {
    const user = JSON.parse(localStorage.getItem("user"));
    // console.log("User data for currency:", user);
    const currencyCode = user?.vendorDetails?.currency || "INR"; // default fallback
    return currencySymbols[currencyCode] || currencyCode;
  } catch (err) {
    console.error("Error reading user currency:", err);
    return "₹"; // fallback
  }
}
